// Prepend with ISO date for file to prevent logos with the same filename from being overwritten, a race condition is unlikely to occur, but is not impossible
export default function newFileWithISOName (file: File): File {
  const _file = new File(
    [file], 
    `${new Date().valueOf()}-${file.name}`,
    {
      type: file.type,
      lastModified: file.lastModified,
    });
  return _file;
}
